import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueMeta from 'vue-meta'

import './plugins/bootstrap-vue'
import NavBar from './components/common/nav-bar'
import HeaderContent from './components/individual/header-content'
import Header from './components/individual/header'
import Footer from './components/common/footer'
import Headings from './components/common/headings'
import axios from 'axios'



import VueAnalytics from 'vue-analytics'
import VueLazyload from 'vue-lazyload'
router.beforeEach((to, from, next) => {
  document.title = to.meta.title || 'ftcash';
  next();
});
Vue.use(VueMeta, {
  keyName: 'metaInfo',
  attribute: 'data-vue-meta',
  refreshOnceOnNavigation: true


});

Vue.use(VueLazyload, {
  lazyComponent: true
});


// Google Analytics
Vue.use(VueAnalytics, {
  id: 'UA-155758379-2',
  router
})

// Waypoint plugin
 
Vue.prototype.$axios = axios
Vue.config.productionTip = false

Vue.component('NavBar', NavBar)
Vue.component('HeaderContent', HeaderContent)
Vue.component('Header', Header)
Vue.component('Footer', Footer)
Vue.component('Headings', Headings)


new Vue({
  render: h => h(App),
  router
}).$mount('#app')
